import FormColor from './form/FormColor'
import api from '../../utils/api'
import { useState } from 'react'
/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function NewColor({ providerId, btCancelAction, handleSubmit, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerColor(obj) {

        let msgType = 'success'

        const data = await api.post(`/color/new`, obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            }
        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <FormColor title="Cadastrar Cor" btnText="Cadastrar" handleSubmit={registerColor} providerId={providerId} btCancelAction={btCancelAction} />
    )
}

export default NewColor